import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  XrkTable,
  XrkTableRef,
  XrkTableProps,
  useTableColumn,
  useSelectColumn,
  useInputColumn,
  useDatePickerColumn,
  BaseButton,
  BaseIcon,
  BaseDropdown,
  BaseDropdownMenu,
  BaseDropdownItem,
  useCreateModal,
  XrkMessage,
  BaseImageViewer,
  BaseButtonMore
} from 'xrk-components';
import { ArrowDown } from '@element-plus/icons-vue';
import { formatter } from '@/utils';
import { parkPageList } from '@data-source/park/apis';
import { OPEN_STATUS } from '@constants/bank';
import {
  LICENSE_AUDIT_STATUS,
  INDIVIDUAL_AUTH_STATUS,
  INDIVIDUAL_TYPE,
  SOURCE
} from '../constants';
import {
  individualInfoList,
  exportDataPackage,
  exportAllDataPackage
} from '../data-source/apis';
import AddOneDialog from '../components/add-one-dialog.vue';
// import AddBatchDialog from '../components/add-batch-dialog.vue';
import { pushDetail } from '../router';
// import { cancelColumn } from '@/views/client-mgmt/src/filelds/columns';
import { ACCOUNT_STATUS } from '@constants/user';
import { CostListDialog } from '../components/cost/index';


export default /*#__PURE__*/_defineComponent({
  ...{
  name: 'individual-household-list'
},
  __name: 'list',
  setup(__props) {



const previewUrl = ref(null);
const body = document.body;

const route = useRoute();
const router = useRouter();
const xrkTableRef = ref<XrkTableRef>(null);

const selectionRows = computed(() => {
  return xrkTableRef.value?.getSelectionRows() || [];
});
const getListAjax = async params => {
  if (route?.query?.businessParkName) {
    xrkTableRef.value.setSearchValue(
      'businessParkId',
      +route?.query?.businessParkId
    );
    params.businessParkId = +route?.query?.businessParkId;
  }
  return individualInfoList(params);
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置',
    beforeReset: value => {
      router.replace({
        query: {}
      });
      return value;
    }
  },
  searchColumns: [
    useInputColumn({
      prop: 'individualName',
      label: '个体工商户名称',
      config: {
        type: 'text',
        placeholder: '请输入'
      }
    }),
    useInputColumn({
      prop: 'entpCertNo',
      label: '统一社会信用代码',
      config: {
        type: 'text',
        placeholder: '请输入'
      }
    }),
    useInputColumn({
      prop: 'operator',
      label: '经营者',
      config: {
        type: 'text',
        placeholder: '请输入'
      }
    }),
    useInputColumn({
      prop: 'phone',
      label: '手机号',
      config: {
        type: 'text',
        placeholder: '请输入'
      }
    }),
    useInputColumn({
      prop: 'idCard',
      label: '身份证号',
      config: {
        type: 'text',
        placeholder: '请输入'
      }
    }),
    useSelectColumn({
      prop: 'auditStatus',
      label: '个体户证照状态',
      config: {
        placeholder: '请选择',
        options: Object.values(LICENSE_AUDIT_STATUS)
      }
    }),
    useSelectColumn({
      prop: 'individualAuthStatus',
      label: '个体户认证状态',
      config: {
        placeholder: '请选择',
        options: INDIVIDUAL_AUTH_STATUS
      }
    }),
    useSelectColumn({
      prop: 'status',
      label: '账户状态',
      config: {
        placeholder: '请选择账号状态',
        clearable: true,
        options: Object.values(ACCOUNT_STATUS)
      }
    }),
    useSelectColumn({
      prop: 'businessParkId',
      label: '所属园区',
      config: {
        placeholder: '请选择所属园区',
        clearable: true,
        filterUseRemote: true,
        init: Boolean(+route?.query?.businessParkId),
        remoteMethod: async (val: string) => {
          const resp = await parkPageList({
            businessParkName: val,
            pageSize: 200
          });

          if (
            route?.query?.businessParkId &&
            !resp?.data?.list.some(
              item => item.id === +route?.query?.businessParkId
            )
          ) {
            resp.data.list.unshift({
              id: +route?.query?.businessParkId,
              businessParkName: route?.query?.businessParkName
            } as any);
          }

          return resp;
        },
        labelKey: 'businessParkName',
        valueKey: 'id'
      }
    }),
    useSelectColumn({
      prop: 'individualType',
      label: '个体户类别',
      config: {
        placeholder: '请选择',
        options: INDIVIDUAL_TYPE
      }
    }),
    useSelectColumn({
      prop: 'source',
      label: '来源',
      config: {
        placeholder: '请选择',
        options: SOURCE
      }
    }),
    useDatePickerColumn({
      prop: 'time1',
      label: '创建时间',
      config: {
        type: 'daterange',
        startPlaceholder: '时间始',
        endPlaceholder: '时间止',
        clearable: true
      },
      listener: {
        onChange: (value, searchObj) => {
          if (!value) {
            searchObj.createAtStart = '';
            searchObj.createAtEnd = '';
          } else {
            searchObj.createAtStart = value[0];
            searchObj.createAtEnd = value[1];
          }
        }
      }
    })
  ],
  otherComponents: [
    {
      render() {
        return (
          <BaseDropdown
            v-slots={{
              dropdown: () => (
                <>
                  <BaseDropdownMenu>
                    <BaseDropdownItem
                      onClick={() => {
                        useCreateModal(AddOneDialog, {
                          onSuccess: () => {
                            xrkTableRef.value.initCurrentList();
                          }
                        });
                      }}
                    >
                      单独添加
                    </BaseDropdownItem>
                    {/* 产品让先去掉，20251030王燕 */}
                    {/* <BaseDropdownItem
                      onClick={() => {
                        useCreateModal(AddBatchDialog, {
                          onSuccess: () => {
                            xrkTableRef.value.initCurrentList();
                          }
                        });
                      }}
                    >
                      批量添加
                    </BaseDropdownItem> */}
                  </BaseDropdownMenu>
                </>
              )
            }}
          >
            <BaseButton v-resource={[['添加个体户']]} type="primary2">
              添加个体户
              <BaseIcon class="el-icon--right" style="margin-left: 4px;">
                <ArrowDown />
              </BaseIcon>
            </BaseButton>
          </BaseDropdown>
        );
      }
    },
    {
      render() {
        return (
          <BaseButton
            style="margin-left: 12px;"
            type="primary2"
            click={async () => {
              if (!selectionRows.value.length) {
                XrkMessage.warning('请选择需要导出的数据');
                return;
              }
              await exportDataPackage({
                idList: selectionRows.value.map(item => item.id)
              });
              XrkMessage.success('操作成功，请前往下载中心进行下载查看');
            }}
          >
            导出
          </BaseButton>
        );
      }
    },
    {
      render() {
        return (
          <BaseButton
            style="margin-left: 12px;"
            type="primary2"
            click={async () => {
              await exportAllDataPackage();
            }}
          >
            导出全量
          </BaseButton>
        );
      }
    }
  ]
});
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: 'id',
      align: 'center',
      fixed: 'left',
      width: 120,
      selectionDisabled(row) {
        return !row.canDownloadResourcePack;
      },
      addSelectionRow: (rowId, row) => {
        // if (selectionRows.value.length < 15) {
        xrkTableRef.value?.addSelectionRow?.(rowId, row);
        // }
      }
    }),
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px',
      fixed: 'left'
    }),
    useTableColumn({
      label: '个体工商户名称',
      prop: 'individualName',
      width: 300
    }),
    useTableColumn({
      label: '账户状态',
      prop: 'status',
      formatter: ({ cellValue }) => ACCOUNT_STATUS[cellValue]?.label
    }),
    useTableColumn({
      label: '统一社会信用代码',
      prop: 'entpCertNo',
      width: '180px'
    }),
    useTableColumn({
      label: '经营者姓名',
      prop: 'operator',
      formatter: ({ cellValue }) => formatter.maskName(cellValue)
    }),
    useTableColumn({
      label: '手机号',
      prop: 'phone',
      formatter: ({ cellValue }) => formatter.maskPhone(cellValue)
    }),
    useTableColumn({
      label: '所属园区',
      prop: 'businessParkName'
    }),
    useTableColumn({
      label: '个体户认证状态',
      prop: 'individualAuthStatus',
      width: '180px',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(INDIVIDUAL_AUTH_STATUS[cellValue]?.label)
    }),
    useTableColumn({
      label: '富友支付',
      prop: 'accountOpeningStatus',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(OPEN_STATUS[cellValue]?.label)
    }),
    useTableColumn({
      label: '个体户类别',
      prop: 'individualType',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(INDIVIDUAL_TYPE[cellValue]?.label)
    }),
    useTableColumn({
      label: '个体户证照状态',
      prop: 'auditStatus',
      width: '180px',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(LICENSE_AUDIT_STATUS[cellValue]?.label)
    }),
    useTableColumn({
      label: '来源',
      prop: 'source',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(SOURCE[cellValue]?.label)
    }),
    useTableColumn({
      label: '服务有效期',
      prop: 'periodOfValidity',
      minWidth: 200
    }),
    useTableColumn({
      label: '创建时间',
      prop: 'createAt',
      width: 180,
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '更新时间',
      prop: 'updateAt',
      width: 180,
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '操作账号',
      prop: 'updateBy'
    }),
    useTableColumn({
      label: '代办供应商',
      prop: 'proxyEnterpriseName',
      width: '180px'
    }),
    useTableColumn({
      label: '地址',
      prop: 'address',
      width: '180px'
    }),
    useTableColumn({
      label: '操作',
      fixed: 'right',
      width: '260px',
      render: ({ row }) => {
        const { auditStatus, businessIndividualId, individualType } = row;

        const btns = [
          // 客户个体审核中不展示，其他都展示
          !(auditStatus == 11 && individualType === 2) && {
            content: '基础信息详情',
            click: () => {
              pushDetail({
                id: businessIndividualId,
                enterType: 'detail'
              });
            }
          },
          // 代办供应商-园区审核，审核中展示，可编辑部分内容
          auditStatus == 21 &&
            individualType === 3 && {
              content: '上传证照',
              click: () => {
                pushDetail({
                  id: businessIndividualId,
                  enterType: 'parkAudit'
                });
              }
            },
          {
            content: '成本列支明细',
            click: () => {
              useCreateModal(CostListDialog, {
                individualId: row.businessIndividualId
              });
            }
          }
        ].filter(Boolean);

        return (
          <>
            <BaseButtonMore
              key={Date.now()}
              maxCount={2}
              style={{ 'justify-content': 'right' }}
              btns={btns}
            ></BaseButtonMore>
          </>
        );
      }
    })
  ]
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"]),
    (_openBlock(), _createBlock(_Teleport, { to: _unref(body) }, [
      (previewUrl.value)
        ? (_openBlock(), _createBlock(_unref(BaseImageViewer), {
            key: 0,
            fullScreen: "",
            previewSrcList: [previewUrl.value],
            onClose: _cache[0] || (_cache[0] = () => (previewUrl.value = null))
          }, null, 8, ["previewSrcList"]))
        : _createCommentVNode("", true)
    ], 8, ["to"]))
  ]))
}
}

})